<template>
  <v-layout wrap>
    <v-flex xs12>
      <v-card>
        <Subheader v-model="search" title="Continuous Data Stations" search="continuous data stations">
          <v-btn small color="success" @click="clickAddStationLink()">
            <v-icon class="mr-1">add</v-icon>
            {{ $t('Button.add_link') }}
          </v-btn>
        </Subheader>
        <v-card-text>
          <v-data-table :headers="headers" :items="continuousDataStations" :pagination.sync="pagination" :search="search" item-key="name">
            <template slot="items" slot-scope="props">
              <tr @click="getStationParameters(props)" class="pointer">
                <td>{{ props.item.name }}</td>
                <td class="text-xs-right">
                  <v-btn small dark color="delete" @click.native="clickUnlink(props.item)" @click.stop>
                    <v-icon class="mr-1">delete_forever</v-icon>
                    {{ $t('Button.unlink') }}
                  </v-btn>
                  <v-icon>keyboard_arrow_down</v-icon>
                </td>
              </tr>
            </template>
            <template slot="expand" slot-scope="props">
              <v-progress-linear v-show="isRequesting" :indeterminate="true" color="secondary"></v-progress-linear>
              <v-card flat class="backgroundColor">
                <v-card-text>
                  <v-form v-model="valid" ref="form" lazy-validation style="width: 100%">
                    <v-list three-line style="padding: 0px">
                      <v-list-tile class="backgroundColor">
                        <v-spacer></v-spacer>
                        <v-btn color="success" small @click="addTagForAllDialog = true">
                          <v-icon class="mr-1">add</v-icon>{{ $t('Button.Add_tag_for_all') }}
                        </v-btn>
                        <v-btn color="error" small @click="removeTagForAllDialog = true">
                          <v-icon class="mr-1">delete_forever</v-icon>{{ $t('Button.REMOVETAGFORALL') }}
                        </v-btn>
                      </v-list-tile>
                      <v-list-tile class="backgroundColor">
                        <v-layout wrap>
                          <v-flex xs12 sm12 md12 lg6>
                            <v-checkbox v-model="checkedAll" color="primary" style="padding-top:10px;float: left;"></v-checkbox>
                            <v-subheader style="font-size: 16px;font-weight: bold;float: left;">Select All</v-subheader>
                          </v-flex>
                          <v-flex xs4 sm4 md4 lg2>
                            <v-subheader style="font-size: 16px;font-weight: bold;padding: 0px">Start Date:
                            </v-subheader>
                          </v-flex>
                          <v-flex xs4 sm4 md4 lg2>
                            <v-subheader style="font-size: 16px;font-weight: bold;padding: 0px">End Date:</v-subheader>
                          </v-flex>
                          <v-flex xs4 sm4 md4 lg2>
                            <v-subheader style="font-size: 16px;font-weight: bold;padding: 0px">Tag:</v-subheader>
                          </v-flex>
                        </v-layout>
                      </v-list-tile>
                      <v-divider light></v-divider>
                      <template v-for="(item, i) in accessInfo">
                        <v-list-tile class="backgroundColor" v-bind:key="i">
                          <v-layout wrap>
                            <v-flex xs12 sm12 md12 lg6 class="d-flex align-center justify-space-">
                              <v-checkbox :id="item.DataSetIdentifer" color="info" style="flex-grow: 0!important;" hide-details v-model="item.Checked" :label="item.DataSetIdentifer"></v-checkbox>
                              <v-btn style="flex-grow: 0!important;" @click="copyText(item.DataSetIdentifer)"  icon flat color="secondary">
                                <v-icon>content_copy</v-icon>
                              </v-btn>
                            </v-flex>
                            <v-flex xs4 sm4 md4 lg2>
                              <v-menu lazy :close-on-content-click="false" v-model="item.startMenu" transition="scale-transition" offset-y full-width :nudge-right="35" max-width="290px" min-width="290px" style="padding-right: 30px">
                                <v-text-field slot="activator" v-model="item.FirstRecordDate" prepend-icon="event" readonly></v-text-field>
                                <v-date-picker v-model="item.FirstRecordDate" no-title scrollable actions :max="item.LastRecordDate"></v-date-picker>
                              </v-menu>
                            </v-flex>
                            <v-flex xs4 sm4 md4 lg2>
                              <v-menu lazy :close-on-content-click="false" v-model="item.endMenu" transition="scale-transition" offset-y full-width :nudge-right="35" max-width="290px" min-width="290px" style="padding-right: 30px">
                                <v-text-field slot="activator" v-model="item.LastRecordDate" prepend-icon="event" readonly></v-text-field>
                                <v-date-picker v-model="item.LastRecordDate" no-title scrollable actions :min="item.FirstRecordDate"></v-date-picker>
                              </v-menu>
                            </v-flex>
                            <v-flex xs4 sm4 md4 lg2>
                              <ComboBoxWithSelectAll v-model="item.Tags" :items="tagSelectList" :elementMaxLength="13">
                              </ComboBoxWithSelectAll>
                            </v-flex>
                          </v-layout>
                        </v-list-tile>
                        <v-divider :key="`tile-${i}`" v-if="$vuetify.breakpoint.mdAndDown" />
                      </template>
                    </v-list>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-progress-circular v-show="isRequesting" style="margin-right:5px;" :indeterminate="true" color="blue"></v-progress-circular>
                  <v-btn color="success" small @click="clickSave()">
                    <v-icon class="mr-1">done</v-icon>
                    {{ $t('Button.Save') }}
                  </v-btn>
                  <v-btn color="secondary" small>{{ $t('Button.Cancel') }}</v-btn>
                </v-card-actions>
              </v-card>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-flex>

    <v-dialog v-model="dialog" max-width="800px">
      <v-flex xs12>
        <v-toolbar dense color="secondary" dark class="removePadding">
          <v-toolbar-title>{{ $t('AdministrationContinuousDataStations.addTitleMsg') }}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
      </v-flex>
      <v-card>
        <v-card-text>
          <v-layout wrap>
            <v-flex xs12 pa-3>
              <v-autocomplete v-model="newStation" label="Station Name" :items="residueContinuousDataStations" item-text="Name" item-value="Name"></v-autocomplete>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" small @click="clickSaveNewStationLink()">
            <v-icon>done</v-icon>
            {{ $t('Button.Save') }}
          </v-btn>
          <v-btn outline color="secondary" small @click="dialog = false">{{ $t('Button.Cancel') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="comfirmDialog" max-width="800">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>{{ $t('AdministrationContinuousDataStations.confirmTitleMsg', { msg: unlinkStation.name }) }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="comfirmDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>{{ $t('AdministrationContinuousDataStations.confirmTextMsg') }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click.native="agreeUnlinkStation()">
            <v-icon class="mr-1">delete_forever</v-icon>{{ $t('Button.UNLINK_STATION') }}
          </v-btn>
          <v-btn outline color="secondary" @click.native="comfirmDialog = false">{{ $t('Button.Cancel') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="addTagForAllDialog" max-width="800px">
      <v-flex xs12>
        <v-toolbar dense color="secondary" dark class="removePadding">
          <v-toolbar-title>{{ $t('AdministrationContinuousDataStations.addTagTitleMsg') }}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
      </v-flex>
      <v-card>
        <v-card-text>
          <v-layout wrap>
            <v-flex xs12 pa-3>
              <!-- <v-text-field label="Station Name" v-model="newStation" /> -->
              <v-radio-group v-model="addTagToAllRadio">
                <v-radio value="All" label="All"></v-radio>
                <v-radio value="Only Assigned" label="Only Assigned"></v-radio>
              </v-radio-group>
              <ComboBoxWithSelectAll v-model="addToAllTagList" :items="tagSelectList" label="Tags" :maxLength="10">
              </ComboBoxWithSelectAll>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" small @click="AddTagToAll()">
            <v-icon class="mr-1">add</v-icon>
            {{ $t('Button.Add') }}
          </v-btn>
          <v-btn outline color="secondary" small @click="addTagForAllDialog = false">{{ $t('Button.Cancel') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="removeTagForAllDialog" max-width="800px">
      <v-flex xs12>
        <v-toolbar dense color="secondary" dark class="removePadding">
          <v-toolbar-title>Remove Tag For All</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
      </v-flex>
      <v-card>
        <v-card-text>
          <v-layout wrap>
            <v-flex xs12 pa-3>
              <ComboBoxWithSelectAll v-model="removeToAllTagList" :items="tagSelectList" label="Tags" :maxLength="10">
              </ComboBoxWithSelectAll>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" small @click="RemoveTagToAll()">
            <v-icon class="mr-1">delete_forever</v-icon>
            {{ $t('Button.Remove') }}
          </v-btn>
          <v-btn outline color="secondary" small @click="removeTagForAllDialog = false">{{ $t('Button.Cancel') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
  import stringUtils from '@/string-utils'

  import { copyToClipboard } from '@/helpers/strings'
  import ComboBoxWithSelectAll from '@/components/ComboBoxWithSelectAll'
  import moment from 'moment'

  import { createNamespacedHelpers } from 'vuex'
  const app = createNamespacedHelpers('app')
  const admin = createNamespacedHelpers('admin')
  const stations = createNamespacedHelpers('stations')
  const authenticate = createNamespacedHelpers('authenticate')
  const navigation = createNamespacedHelpers('navigation')
  export default {
    components: {
      ComboBoxWithSelectAll,
    },
    props: {
      name: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        search: '',
        pagination: {
          rowsPerPage: 5,
        },
        headers: [{
          align: 'left',
          text: 'Station',
          value: 'name',
        },
        {
          align: 'left',
          sortable: false,
        },
        ],
        valid: '',
        dialog: false,
        comfirmDialog: false,
        deleteState: '',
        newStation: '',
        unlinkStation: '',
        currentStation: '',
        accessInfo: [],
        addTagForAllDialog: false,
        removeTagForAllDialog: false,
        addToAllTagList: [],
        removeToAllTagList: [],
        addTagToAllRadio: 'Only Assigned',
        isRequesting: false,
      }
    },
    mounted() {
      this.getAllContinuousDataStationsList(this.name)
      this.getContinuousDataStations(this.name)
    },
    computed: {
      ...admin.mapGetters(['roleList', 'allContinuousDataStations', 'continuousDataStationDetail',
        'continuousDataStations',
      ]),
      ...authenticate.mapGetters(['currentTenant']),
      ...stations.mapGetters(['tagList', 'CurrentContinuousStationSideMenuSetting']),
      residueContinuousDataStations() {
        let stationList = JSON.parse(JSON.stringify(this.allContinuousDataStations))
        this.continuousDataStations.forEach(e => {
          let station = stationList.find(i => i.Name == e.name)
          if (station != null) {
            let i = stationList.indexOf(station)
            stationList.splice(i, 1)
          }
        })
        return stationList
      },
      tagSelectList() {
        if (!this.tagList) return []
        return this.tagList.map(tag => tag.TagName)
      },
      tenantData() {
        return this.roleList.find(x => x.RoleName == this.name)
      },
      checkedAll: {
        get() {
          return !this.accessInfo.some(x => !x.Checked)
        },
        set(newValue) {
          let tempAccessInfo = this.accessInfo.map(x => {
            x.Checked = newValue
            return x
          })
          this.accessInfo = tempAccessInfo
        },
      },
      currentTenantName() {
        return this.currentTenant && this.currentTenant.name
      },
    },
    watch: {
      continuousDataStationDetail() {
        let data = JSON.parse(JSON.stringify(this.continuousDataStationDetail))
        data.forEach(e => {
          e.FirstRecordDate ? e.FirstRecordDate = this.formatDateForSentinel(e.FirstRecordDate) : ''
          e.LastRecordDate ? e.LastRecordDate = this.formatDateForSentinel(e.LastRecordDate) : ''
        })
        this.accessInfo = data
      },
    },
    methods: {
      ...app.mapActions(['setSnackbar']),
      ...admin.mapActions(['getAllContinuousDataStationsList', 'getContinuousDataStationDetail',
        'postAddContinuousStationLink', 'postUnlinkContinuousStation', 'getContinuousDataStations',
        'postUpdateContinuousStationLinkTag',
      ]),
      ...navigation.mapActions(['fetchSideMenu']),
      ...stations.mapActions(['setContinuousSideMenuGrouper', 'getTagList']),
      copyText(text) {
        copyToClipboard(text)
        this.setSnackbar({
          icon: 'done',
          color: 'success',
          text: `${text} copied to clipboard.`,
        })
      },
      clickManageStation(data) {
        this.stationId = data.Id
      },
      clickAddStationLink() {
        if (this.residueContinuousDataStations.length == 0) {
          this.setSnackbar({
            icon: 'info',
            color: 'info',
            text: this.$t('AdministrationContinuousDataStations.addStationLinkMsg'),
          })
        } else {
          this.dialog = true
        }
      },
      async clickSaveNewStationLink() {
        if (this.newStation) {
          let tenantName = this.name
          let options = {
            data: {
              TenantName: tenantName,
              StationName: this.newStation,
              Checked: true,
              AccessInfo: null,
            },
            successCb: () => {
              this.getContinuousDataStations(tenantName)
              this.dialog = false
              this.setSnackbar({
                icon: 'done',
                color: 'success',
                text: this.$t('AdministrationContinuousDataStations.saveNewStationLinkSuccessMsg', {
                  msg: this.newStation,
                }),
              })
            },
            failedCb: (err) => {
              this.setSnackbar({
                icon: 'error',
                color: 'error',
                text: err,
              })
            },
          }
          await this.postAddContinuousStationLink(options)
        } else {
          this.setSnackbar({
            icon: 'warning',
            color: 'warning',
            text: this.$t('AdministrationContinuousDataStations.saveNewStationLinkFailMsg'),
          })
        }
      },
      async clickSave() {
        var that = this
        this.isRequesting = true
        let data = JSON.parse(JSON.stringify(this.accessInfo))
        let tagData = []
        data.forEach(e => {
          e.LastRecordDate ? e.LastRecordDate = moment(e.LastRecordDate).hour(23).minute(59).second(59)
            .format() : ''
          tagData.push({
            TenantId: that.tenantData.Id,
            ParameterId: e.TimeSeriesId,
            Tags: e.Tags,
          })
        })
        let options = {
          data: {
            TenantName: this.name,
            StationName: this.currentStation.name,
            Checked: true,
            AccessInfo: data,
          },
          successCb: () => {
            this.setSnackbar({
              icon: 'done',
              color: 'success',
              text: this.$t('AdministrationContinuousDataStations.saveSuccessMsg', {
                msg: this.currentStation.name,
              }),
            })

            this.isRequesting = false
          },
          failedCb: (err) => {
            this.setSnackbar({
              icon: 'error',
              color: 'error',
              text: err,
            })
            this.isRequesting = false
          },
        }
        await this.postAddContinuousStationLink(options)
        await this.postUpdateContinuousStationLinkTag(tagData)
        const tenantBeingManagedIsAccountTenant = this.name == this.currentTenantName
        if (tenantBeingManagedIsAccountTenant) {
          await this.fetchSideMenu({})
        }
      },
      agreeUnlinkStation() {
        let tenantName = this.name
        let options = {
          data: {
            TenantName: tenantName,
            StationName: stringUtils.fixedEncodeURIComponent(this.unlinkStation.name),
          },
          successCb: () => {
            this.getContinuousDataStations(tenantName)
            this.setSnackbar({
              icon: 'done',
              color: 'success',
              text: this.$t('AdministrationContinuousDataStations.unlinkStationSuccessMsg', {
                msg: this.unlinkStation.name,
              }),
            })

            this.comfirmDialog = false
          },
          failedCb: (err) => {
            this.setSnackbar({
              icon: 'error',
              color: 'error',
              text: err,
            })
          },
        }
        this.postUnlinkContinuousStation(options)
      },
      getStationParameters(props) {
        if (props.expanded) {
          props.expanded = !props.expanded
          return
        }
        let options = {
          data1: this.name,
          data2: stringUtils.fixedEncodeURIComponent(props.item.name),
          successCb: () => {
            props.expanded = !props.expanded
            this.currentStation = props.item
          },
        }
        this.getContinuousDataStationDetail(options)
      },
      clickUnlink(station) {
        this.comfirmDialog = true
        this.unlinkStation = station
      },
      formatDateForSentinel(dateTimeString) {
        return moment(dateTimeString).format('YYYY-MM-DD')
      },
      AddTagToAll() {
        let data = JSON.parse(JSON.stringify(this.accessInfo))
        
        if (this.addTagToAllRadio == 'Only Assigned') {
          data.forEach(e => {
            if (e.Checked) {
              if(!e.Tags) {
                e.Tags = []
              }
              let temp = new Set([...e.Tags, ...this.addToAllTagList])
              e.Tags = Array.from(temp)
            }
          })
        } else {
          data.forEach(e => {
            if(!e.Tags) {
              e.Tags = []
            }
            let temp = new Set([...e.Tags, ...this.addToAllTagList])
            e.Tags = Array.from(temp)
          })
        }
        this.accessInfo = data
        this.addToAllTagList = []
        this.addTagForAllDialog = false
      },
      RemoveTagToAll() {
        let data = JSON.parse(JSON.stringify(this.accessInfo))
        this.removeToAllTagList.forEach(x => {
          data.forEach(e => {
            let i = e.Tags.indexOf(x)
            if (i > -1) {
              e.Tags.splice(i, 1)
            }
          })
        })
        this.accessInfo = data
        this.removeToAllTagList = []
        this.removeTagForAllDialog = false
      },
    },
  }
</script>

<style scoped>
  .pointer {
    cursor: pointer;
  }

  .backgroundColor {
    background-color: #fafafa;
  }

  .removePadding {
    padding: 0px;
  }
</style>